import React from 'react'
import { TimelineItemContentBadgeTypeT } from 'components/Timeline/types'
import { EventsOfTask } from 'pages/Tasks/types'
import TimelineBadge from 'redesign/components/molecules/timeline-badge'
import { TIMELINE_BADGE_VARIANTS } from 'redesign/components/molecules/timeline-badge/constants'
import type { TimelineBadgeProps } from 'redesign/components/molecules/timeline-badge/types'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { ResolveActionButtonsProps } from 'redesign/components/templates/task-details-action-buttons/types'
import { getCommentButton } from 'redesign/components/templates/task-details-action-buttons/utils/get-comment-button'
import { getBadgeProps } from 'redesign/components/templates/timeline/get-badge-props'
import type { MessageDrawerProps } from 'redesign/services/timeline-action-button/types'

export const getClaimButton = ({ sendEvent, refetch, setMessageDrawerProps, t, task }: ResolveActionButtonsProps) => {
  const taskHasRequestedChange = Boolean(
    task.timeline?.find(
      (timelineItem) => timelineItem && timelineItem.badge === TimelineItemContentBadgeTypeT.wtcChangeRequest,
    ),
  )
  const claimBadgeProps: TimelineBadgeProps = getBadgeProps({
    isOffice: false,
    badgeType: TimelineItemContentBadgeTypeT.wtcChangeRequest,
  }) || { variant: TIMELINE_BADGE_VARIANTS.success, text: '' }

  const claimDrawerProps: Partial<MessageDrawerProps> = {
    headerLabel: <TimelineBadge {...claimBadgeProps} skipTooltipText />,
    placeholder: t('workTimeControl.requestChange.inputPlaceholder'),
    commentText: t('workTimeControl.requestChange.body'),
  }
  const claimButtonProps = {
    label: t('workTimeControl.buttons.requestChange'),
    testId: 'monthly-sheet-detail_claim',
    color: 'inherit' as Action['color'],
  }

  // The claim button is shown as either a common comment button or a claim button with extra explanation based on previous actions in the timeline
  const claimButton: Action = {
    ...getCommentButton({
      t,
      sendEvent,
      refetch,
      setMessageDrawerProps,
      taskEvent: EventsOfTask.monthlySheetSendCommentToManager,
      ...(!taskHasRequestedChange && { drawerProps: claimDrawerProps, buttonProps: claimButtonProps }),
    }),
  }

  return claimButton
}
